import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { ActivatedRoute } from '@angular/router';
import { Data } from '../../models/data';
import { NavController } from '@ionic/angular';
import { BarcodeScannerOptions, BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpHeaders } from '@angular/common/http';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-posm',
  templateUrl: './posm.page.html',
  styleUrls: ['./posm.page.scss'],
})
export class PosmPage implements OnInit {

  myresult: any;
  isCompleted = false;
  isCompleted2 = false;
  isCompleted3 = false;
  isLinear = true;

  invalid1: any;
  invalid2: any;

  ipAddress: any;

  data = new Data();
  myId: any;
  custId: any;

  preacceptance_data = new Data();
  connote_data = new Data();
  tariff_data = new Data();
  posm_data = new Data();

  is_sender_firstname = false;
  is_sender_address1 = false;
  is_sender_address2 = false;
  is_sender_email = false;
  is_sender_postcode = false;
  is_sender_city = false;
  is_sender_state = false;
  is_sender_phone = false;
  is_receiver_firstname = false;
  is_receiver_address1 = false;
  is_receiver_address2 = false;
  //is_receiver_email = false;
  is_receiver_postcode = false;
  is_receiver_city = false;
  is_receiver_state = false;
  is_receiver_phone1 = false;
  is_receiver_phone2 = true;
  is_parcel_item = false;
  is_parcel_weight = false;
  is_parcel_length = false;
  is_parcel_height = false;
  is_parcel_width = false;
  is_parcel_content = false;
  is_parcel_description = false;
  is_parcel_payment = false;

  msg_sender_postcode = 'Postcode is required';
  msg_sender_phone = 'Phone is required';
  msg_sender_email = 'Email is required';
  //msg_receiver_email = 'Email is required';
  msg_receiver_postcode = 'Postcode is required';
  msg_receiver_phone1 = 'Phone 1 is required';
  msg_receiver_phone2 = 'Phone 2 is required';
  msg_parcel_weight = 'Item weight is required';
  msg_parcel_length = 'Item length is required';
  msg_parcel_width = 'Item width is required';
  msg_parcel_height = 'Item height is required';


  pre_id = 0;

  pre_dealer_pickupLocationID: any;
  pre_dealer_pickupLocationName: any;
  pre_dealer_contactPerson: any;
  pre_dealer_phoneNo: any;
  pre_dealer_pickupAddress: any;
  pre_dealer_postCode: any;
  pre_dealer_pickupDistrict: any;
  pre_dealer_pickupProvince: any;
  pre_dealer_pickupEmail: any;
  pre_dealer_subAccount: any;

  pre_sender_firstname: any;
  pre_sender_lastname = '';
  pre_sender_ic: any;
  pre_sender_address1: any;
  pre_sender_address2: any;
  pre_sender_email = '';
  pre_sender_postcode: any;
  pre_sender_city: any;
  pre_sender_state: any;
  pre_sender_phone: any;

  pre_receiver_firstname: any;
  pre_receiver_lastname = '';
  pre_receiver_ic: any;
  pre_receiver_address1: any;
  pre_receiver_address2: any;
  pre_receiver_email = '';
  pre_receiver_postcode: any;
  pre_receiver_city: any;
  pre_receiver_state: any;
  pre_receiver_phone1: any;
  pre_receiver_phone2 = '';

  pre_parcel_item: any;
  pre_parcel_quantity: any;
  pre_parcel_weight: any;
  pre_parcel_amount: any;
  pre_parcel_payment: any;
  pre_parcel_content: any;
  pre_parcel_description: any;
  pre_parcel_width: any;
  pre_parcel_height: any;
  pre_parcel_length: any;



  pre_parcel_remarks = '';

  update = 0;


  constructor(private apiService: ApiService, private http: HttpClient, private activatedRoute: ActivatedRoute, private barcodeScanner: BarcodeScanner, private navCtrl: NavController, public dialog: MatDialog, private spinner: NgxSpinnerService) {
    this.myresult = '';
    this.myId = this.activatedRoute.snapshot.paramMap.get('myid');
    this.custId = this.activatedRoute.snapshot.paramMap.get('custid');
    const user = localStorage.getItem('user');

    this.data = {
      id: 3,
      name: 'getParamDashboard',
      content: user
    };


  }

  ngOnInit() {

    this.getIPAddress();

    this.apiService.postData(this.data).subscribe((response) => {
      console.log(response);
      this.pre_dealer_pickupLocationID = response.data.user.customer_id;
      this.pre_dealer_pickupLocationName = response.data.user.company;
      this.pre_dealer_contactPerson = response.data.user.contact;
      this.pre_dealer_phoneNo = response.data.user.telephone;
      this.pre_dealer_pickupAddress = response.data.user.addr;
      this.pre_dealer_postCode = response.data.user.postcode;
      this.pre_dealer_pickupDistrict = response.data.user.city;
      this.pre_dealer_pickupProvince = response.data.user.state;
      this.pre_dealer_pickupEmail = response.data.user.email;
      this.pre_dealer_subAccount = response.data.user.sub_account;

      if (this.custId > 0) {

        this.data = {
          id: 3,
          name: 'posTransactionbyCust',
          content: this.custId
        };

        console.log(this.data);

        this.apiService.postData(this.data).subscribe((response) => {

          this.pre_sender_firstname = response.data.user_firstname;
          this.pre_sender_lastname = response.data.user_lastname;
          this.pre_sender_ic = response.data.user_ic;
          this.pre_sender_address1 = response.data.user_address1;
          this.pre_sender_address2 = response.data.user_address2;
          this.pre_sender_email = response.data.user_email;
          this.pre_sender_postcode = response.data.user_postcode;
          this.pre_sender_city = response.data.user_city;
          this.pre_sender_state = response.data.user_state;
          this.pre_sender_phone = response.data.user_mobile;

          console.log(response);
          this.isCompleted = true;
        });

      } else {
        if (this.myId > 0) {
          this.data = {
            id: 3,
            name: 'posTransactionbyId',
            content: this.myId
          };

          console.log(this.data);

          this.apiService.postData(this.data).subscribe((response) => {

            this.pre_sender_firstname = response.data.sender_firstname;
            this.pre_sender_lastname = response.data.sender_lastname;
            this.pre_sender_ic = response.data.sender_ic;
            this.pre_sender_address1 = response.data.sender_address1;
            this.pre_sender_address2 = response.data.sender_address2;
            this.pre_sender_email = response.data.sender_email;
            this.pre_sender_postcode = response.data.sender_postcode;
            this.pre_sender_city = response.data.sender_city;
            this.pre_sender_state = response.data.sender_state;
            this.pre_sender_phone = response.data.sender_mobile;

            this.pre_receiver_firstname = response.data.receiver_firstname;
            this.pre_receiver_lastname = response.data.receiver_lastname;
            this.pre_receiver_ic = response.data.receiver_ic;
            this.pre_receiver_address1 = response.data.receiver_address1;
            this.pre_receiver_address2 = response.data.receiver_address2;
            this.pre_receiver_postcode = response.data.receiver_postcode;
            this.pre_receiver_city = response.data.receiver_city;
            this.pre_receiver_state = response.data.receiver_state;
            this.pre_receiver_phone1 = response.data.receiver_mobile1;
            this.pre_receiver_phone2 = response.data.receiver_mobile1;
            this.pre_receiver_email = response.data.receiver_email;

            this.pre_parcel_item = response.data.item_type;
            this.pre_parcel_content = response.data.item_content_value;
            this.pre_parcel_description = response.data.item_description;
            this.pre_parcel_remarks = response.data.item_payment_remarks;
            this.pre_parcel_quantity = response.data.item_quantity;
            this.pre_parcel_weight = response.data.item_weight;
            this.pre_parcel_length = '';
            this.pre_parcel_width = '';
            this.pre_parcel_height = '';
            this.pre_parcel_amount = response.data.item_amount;
            this.pre_parcel_payment = response.data.item_payment_type;

            this.pre_id = response.data.posm_id;

            this.isCompleted = true;
            this.isCompleted2 = true;
            this.update = 1;

            this.is_sender_firstname = true;
            this.is_sender_address1 = true;
            this.is_sender_address2 = true;
            this.is_sender_email = true;
            this.is_sender_postcode = true;
            this.is_sender_city = true;
            this.is_sender_state = true;
            this.is_sender_phone = true;
            this.is_receiver_firstname = true;
            this.is_receiver_address1 = true;
            this.is_receiver_address2 = true;
            //this.is_receiver_email = true;
            this.is_receiver_postcode = true;
            this.is_receiver_city = true;
            this.is_receiver_state = true;
            this.is_receiver_phone1 = true;
            this.is_receiver_phone2 = true;
            this.is_parcel_item = true;
            this.is_parcel_weight = true;
            this.is_parcel_content = true;
            this.is_parcel_description = true;

            console.log(response);
            console.log('isCompleted = ' + this.isCompleted);
            console.log('isCompleted2 = ' + this.isCompleted2);
          });
        }
      }

    });
  }

  getTariff() {

    var calcWeight = 0;

    var weight = (this.pre_parcel_length * this.pre_parcel_width * this.pre_parcel_height) / 6000;

    if (this.pre_parcel_length > 30 || this.pre_parcel_width > 30 || this.pre_parcel_height > 30) {

      if (weight > this.pre_parcel_weight) calcWeight = weight; else calcWeight = this.pre_parcel_weight;

    } else calcWeight = this.pre_parcel_weight;

    const dt = {
      origin: this.pre_dealer_postCode,
      destination: this.pre_receiver_postcode,
      weight: calcWeight,
    };

    this.tariff_data = {
      id: 1,
      name: 'tariff',
      content: dt
    };

    console.log(this.tariff_data);

    this.apiService.tariff(this.tariff_data).subscribe((response) => {
      // this.pre_parcel_amount = Math.round(response[0].totalAmount * 10) / 10;
      console.log(response);
      this.pre_parcel_amount = (Math.round(response[0].totalAmount*20)/20).toFixed(2);
    });
  }

  submit() {

    this.spinner.show();
    // this.navCtrl.navigateForward('/members/success/485');
    /*const passcode =  this.pass[0].toString() + this.pass[1].toString() + this.pass[2].toString() + this.pass[3].toString() + this.pass[4].toString() + this.pass[5].toString();
    console.log(passcode);
    if ( passcode === '123456' ) {*/

    const wallet = localStorage.getItem('wallet');
    const test = wallet.replace(',', '');
    const balance = Number.parseFloat(test) - this.pre_parcel_amount;

    console.log(test + ' ' + balance);

    if (Number.parseFloat(test) >= this.pre_parcel_amount ) {

    const dt1 = {
      mobile: this.pre_parcel_item,
      amount: this.pre_parcel_amount,
      product: '296',
      user: localStorage.getItem('user'),
      order: null,
	  rrp: this.pre_parcel_amount
    };

    this.data = {
      id: 5,
      name: 'addOrder',
      content: dt1
    };

    console.log(this.data);

    this.apiService.pay(this.data).subscribe((response) => {
      this.data.content.order = response;
      this.apiService.wallet(this.data).subscribe((res) => {

        const dt2 = {
          item: '1',
          account: '8800542570',
          order: this.data.content.order,
          origin: this.pre_dealer_postCode,
          destination: this.pre_receiver_postcode
        };

        this.posm_data = {
          id: 1,
          name: 'posm',
          content: dt2
        };

        console.log(this.posm_data);


        this.apiService.pos(this.posm_data).subscribe((response) => {

          const dt3 = {
            subscriptionCode: 'DEX',
            requireToPickup: 'TRUE',
            requireWebHook: 'TRUE',
            accountNo: this.pre_dealer_subAccount,
            callerName: 'Envytech Solutions Sdn Bhd',
            callerPhone: '03-74907762',
            pickupLocationID: this.pre_dealer_pickupLocationID,
            pickupLocationName: this.pre_dealer_pickupLocationName,
            contactPerson: this.pre_dealer_contactPerson,
            phoneNo: this.pre_dealer_phoneNo,
            pickupAddress: this.pre_dealer_pickupAddress,
            postCode: this.pre_dealer_postCode,
            ItemType: this.pre_parcel_item,
            totalQuantityToPickup: 1,
            totalWeight: this.pre_parcel_weight,
            consignmentNoteNumber: response.Connote.ConnoteNo,
            PaymentType: this.pre_parcel_payment,
            amount: this.pre_parcel_amount,
            readyToCollectAt: '12:00 PM',
            closeAt: '06:00 PM',
            senderFname: this.pre_sender_firstname,
            senderLname: this.pre_sender_lastname,
            senderIc: this.pre_sender_ic,
            senderAddress: this.pre_sender_address1,
            senderAddress2: this.pre_sender_address2,
            senderProvince: this.pre_sender_state,
            senderCity: this.pre_sender_city,
            senderPostCode: this.pre_sender_postcode,
            senderEmail: this.pre_sender_email,
            senderPhone: this.pre_sender_phone,
            receiverName: this.pre_receiver_firstname,
            receiverID: '',
            receiverAddress: this.pre_receiver_address1,
            receiverPostCode: this.pre_receiver_postcode,
            receiverEmail: this.pre_receiver_email,
            receiverPhone01: this.pre_receiver_phone1,
            receiverPhone02: this.pre_receiver_phone2,
            sellerReferenceNo: '',
            itemDescription: this.pre_parcel_description,
            itemContentValue: this.pre_parcel_content,
            itemPaymentRemarks: this.pre_parcel_remarks,
            sellerOrderNo: '',
            comments: '',
            pickupDistrict: this.pre_dealer_pickupDistrict,
            pickupProvince: this.pre_dealer_pickupProvince,
            pickupEmail: this.pre_dealer_pickupEmail,
            pickupCountry: 'MY',
            pickupLocation: '',
            receiverFname: this.pre_receiver_firstname,
            receiverLname: this.pre_receiver_lastname,
            receiverIc: this.pre_receiver_ic,
            receiverAddress2: this.pre_receiver_address2,
            receiverDistrict: this.pre_receiver_city,
            receiverProvince: this.pre_receiver_state,
            receiverCity: this.pre_receiver_city,
            receiverCountry: 'MY',
            packDesc: '',
            packVol: '',
            packLeng: this.pre_parcel_length,
            packWidth: this.pre_parcel_width,
            packHeight: this.pre_parcel_height,
            packTotalitem: '',
            orderDate: '',
            packDeliveryType: '',
            ShipmentName: 'Poslaju',
            pickupProv: '',
            deliveryProv: '',
            postalCode: '',
            currency: 'MYR',
            countryCode: 'MY',
            user: localStorage.getItem('user'),
            userType: 1,
            ipAddress: this.ipAddress,
            pl9: '',
            response: '',
            routingCode: response.Routing.RoutingCode,
            orderNo: this.data.content.order,
            status: 1,
            update: this.update,
            pre_id: this.pre_id
          };

          this.preacceptance_data = {
            id: 1,
            name: 'posTransaction',
            content: dt3
          };

          console.log(this.preacceptance_data);

          this.apiService.postData(this.preacceptance_data).subscribe((response) => {

            this.http.get("https://dexmart.dexasia.com.my/index.php?route=common/booking2&order_id=" + this.data.content.order).subscribe((res: any) => { });
            this.navCtrl.navigateForward('/members/posm-ordering/' + this.data.content.order);

    
            const preaccept = {
              id: 1,
              name: 'preacceptance',
              content: this.data.content.order
            };
    
    
            this.apiService.pos(preaccept).subscribe((response) => {
              
              // this.myresult = JSON.stringify(response);
              console.log(response);
              this.spinner.hide();

            });


          });

        });


      });
    });

  } else {
    // this.verify = false;
    this.openDialog('Your balance is unsuffient. Please reload');
    this.spinner.hide();
  }


  }

  checking() {

    if (this.pre_sender_address1 == undefined ||
      this.pre_sender_address1 == null ||
      this.pre_sender_address2 == undefined ||
      this.pre_sender_address2 == null ||
      this.pre_sender_firstname == undefined ||
      this.pre_sender_firstname == null ||
      this.pre_sender_phone == undefined ||
      this.pre_sender_postcode == null ||
      this.pre_sender_postcode == undefined ||
      this.pre_sender_city == null ||
      this.pre_sender_city == undefined ||
      this.pre_sender_state == null ||
      this.pre_sender_state == undefined ||
      this.pre_sender_phone == null
    ) {
      if (this.pre_sender_postcode.toString().length > 5) {
        this.pre_sender_postcode = this.pre_sender_postcode.toString().substring(0, 5);
        this.openDialog('The length of postcode must equal 5');
        this.isCompleted = false;
      } else if (this.pre_sender_postcode.toString().length == 5) {

        var ddd = { postcode: this.pre_sender_postcode };

        var ddtt = {
          id: 1,
          name: 'checkRange',
          content: ddd
        };


        this.apiService.postData(ddtt).subscribe((res) => {
          console.log(res);
          this.invalid2 = res.data[0].isokay;
          console.log(this.invalid2);
          if (this.invalid2 == 2) {
            this.openDialog('The postcode ' + this.pre_sender_postcode + ' is invalid');
            this.pre_sender_postcode = '';
          }
        });
        this.isCompleted = false;

      } else this.isCompleted = false;
    } else {
      if (this.pre_sender_postcode.toString().length > 5) {
        this.pre_sender_postcode = this.pre_sender_postcode.toString().substring(0, 5);
        this.openDialog('The length of postcode must equal 5');
        this.isCompleted = true;
      } else if (this.pre_sender_postcode.toString().length == 5) {

        var ddd = { postcode: this.pre_sender_postcode };

        var ddtt = {
          id: 1,
          name: 'checkRange',
          content: ddd
        };


        this.apiService.postData(ddtt).subscribe((res) => {
          console.log(res);
          this.invalid2 = res.data[0].isokay;
          console.log(this.invalid2);
          if (this.invalid2 == 2) {
            this.openDialog('The postcode ' + this.pre_sender_postcode + ' is invalid');
            this.pre_sender_postcode = '';
          }
        });
        this.isCompleted = true;
      } else this.isCompleted = true;
    }

    this.getTariff();

  }

  checking2() {

    console.log('a');

    if (this.pre_receiver_address1 == undefined ||
      this.pre_receiver_address1 == null ||
      this.pre_receiver_address2 == undefined ||
      this.pre_receiver_address2 == null ||
      this.pre_receiver_firstname == undefined ||
      this.pre_receiver_firstname == null ||
      this.pre_receiver_phone1 == undefined ||
      this.pre_receiver_postcode == null ||
      this.pre_receiver_postcode == undefined ||
      this.pre_receiver_city == null ||
      this.pre_receiver_city == undefined ||
      this.pre_receiver_state == null ||
      this.pre_receiver_state == undefined ||
      this.pre_receiver_phone1 == null
    ) {
      if (this.pre_receiver_postcode.toString().length > 5) {
        this.pre_receiver_postcode = this.pre_receiver_postcode.toString().substring(0, 5);
        this.isCompleted2 = false;
        this.openDialog('The length of postcode must equal 5');
        console.log('f');
      } else if (this.pre_receiver_postcode.toString().length == 5) {
        var ddd = { postcode: this.pre_receiver_postcode };

        var ddtt = {
          id: 1,
          name: 'checkRange',
          content: ddd
        };


        this.apiService.postData(ddtt).subscribe((res) => {

          console.log(res);
          this.invalid2 = res.data[0].isokay;
          console.log(this.invalid2);
          if (this.invalid2 == 2) {
            this.openDialog('The postcode ' + this.pre_receiver_postcode + ' is invalid');
            this.pre_receiver_postcode = '';
          }
        });
        this.isCompleted2 = false;
      } else {
        this.isCompleted2 = false;
        console.log('e');
      }
    } else {
      console.log('b');
      if (this.pre_receiver_postcode.toString().length > 5) {
        console.log('c');
        this.pre_receiver_postcode = this.pre_receiver_postcode.toString().substring(0, 5);
        this.openDialog('The length of postcode must equal 5');
        this.isCompleted2 = true;
      } else if (this.pre_receiver_postcode.toString().length == 5) {
        var ddd = { postcode: this.pre_receiver_postcode };

        var ddtt = {
          id: 1,
          name: 'checkRange',
          content: ddd
        };


        this.apiService.postData(ddtt).subscribe((res) => {

          console.log(res);
          this.invalid2 = res.data[0].isokay;
          console.log(this.invalid2);
          if (this.invalid2 == 2) {
            this.openDialog('The postcode ' + this.pre_receiver_postcode + ' is invalid');
            this.pre_receiver_postcode = '';
          }
        });
        this.isCompleted2 = true;
      } else {
        console.log('d');
        this.isCompleted2 = true;
      }
    }

    this.getTariff();

  }

  checking3() {

    if (this.pre_parcel_item == undefined ||
      this.pre_parcel_item == null ||
      this.pre_parcel_content == undefined ||
      this.pre_parcel_content == null ||
      this.pre_parcel_weight == null ||
      this.pre_parcel_weight == undefined ||
      this.pre_parcel_description == null ||
      this.pre_parcel_description == undefined ||
      this.pre_parcel_length == null ||
      this.pre_parcel_length == undefined ||
      this.pre_parcel_length == 0 ||
      this.pre_parcel_width == null ||
      this.pre_parcel_width == undefined ||
      this.pre_parcel_width == 0 ||
      this.pre_parcel_height == null ||
      this.pre_parcel_height == undefined ||
      this.pre_parcel_height == 0 ||
      this.pre_parcel_payment == null ||
      this.pre_parcel_payment == undefined ||
      this.pre_parcel_payment == ''
    ) {
      if (this.pre_parcel_weight > 30) {
        console.log('dsdskfkdsf');
        this.pre_parcel_weight = '';
        this.openDialog('Max weight is 30 kg');
        this.isCompleted3 = false;
      } else {
        console.log('dsdfyyty');
        console.log(this.pre_parcel_weight);
        this.isCompleted3 = false;
      }
    } else {
      if (this.pre_parcel_weight > 30) {
        console.log('dsdskfkdsf');
        this.pre_parcel_weight = '';
        this.openDialog('Max weight is 30 kg');
        this.isCompleted3 = false;
      }
      else {
        console.log('dsdfyjjjjyty');
        console.log(this.pre_parcel_weight);
        this.isCompleted3 = true;
      }
    }

    console.log(this.isCompleted3);

    this.getTariff();

  }

  sender_firstname() {
    if (this.pre_sender_firstname == null || this.pre_sender_firstname == undefined) {
      this.is_sender_firstname = false;
    }
    else if (this.pre_sender_firstname.length == 0) {
      this.is_sender_firstname = false;
    }
    else if (this.pre_sender_firstname.length == '') {
      this.is_sender_firstname = false;
    }
    else {
      this.is_sender_firstname = true;
    }

    console.log('sender_firstname = ' + this.pre_sender_firstname);
    console.log('is_sender_firstname = ' + this.is_sender_firstname);

    this.checkAll();
  }

  sender_address1() {
    if (this.pre_sender_address1 == null || this.pre_sender_address1 == undefined) {
      this.is_sender_address1 = false;
    }
    else if (this.pre_sender_address1.length == 0) {
      this.is_sender_address1 = false;
    }
    else if (this.pre_sender_address1.length == '') {
      this.is_sender_address1 = false;
    }
    else {
      this.is_sender_address1 = true;
    }

    console.log('sender_address1 = ' + this.pre_sender_address1);
    console.log('is_sender_address1 = ' + this.is_sender_address1);

    this.checkAll();
  }

  sender_address2() {
    if (this.pre_sender_address2 == null || this.pre_sender_address2 == undefined) {
      this.is_sender_address2 = false;
    }
    else if (this.pre_sender_address2.length == 0) {
      this.is_sender_address2 = false;
    }
    else if (this.pre_sender_address2.length == '') {
      this.is_sender_address2 = false;
    }
    else {
      this.is_sender_address2 = true;
    }

    console.log('sender_address2 = ' + this.pre_sender_address2);
    console.log('is_sender_address2 = ' + this.is_sender_address2);

    this.checkAll();
  }

  sender_email() {
    if (this.pre_sender_email == null || this.pre_sender_email == undefined) {
      this.is_sender_email = false;
    }
    else if (this.pre_sender_email.length == 0) {
      this.is_sender_email = false;
    }
    else {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(this.pre_sender_email.toLowerCase())) this.is_sender_email = true;
      else {
        this.is_sender_email = false;
        this.pre_sender_email = '';
        this.msg_sender_email = 'Email format is not valid';
      }

    }

    console.log('sender_email = ' + this.pre_sender_email);
    console.log('is_sender_email = ' + this.is_sender_email);

    this.checkAll();
  }

  sender_postcode() {

    console.log(this.pre_sender_postcode);

    if (this.pre_sender_postcode == null || this.pre_sender_postcode == undefined) {
      this.is_sender_postcode = false;
    }
    else if (this.pre_sender_postcode == '') {
      this.is_sender_postcode = false;
    }
    else if (this.pre_sender_postcode < 1000 || this.pre_sender_postcode > 99999) {
      this.is_sender_postcode = false;
      this.pre_sender_postcode = '';
      this.msg_sender_postcode = 'The postcode length must equal 5';
    }
    else {
      if (this.pre_sender_postcode.toString().match(/^[0-9]+$/) != null) {

        var ddd = { postcode: this.pre_sender_postcode };

        var ddtt = {
          id: 1,
          name: 'checkRange',
          content: ddd
        };

        this.apiService.postData(ddtt).subscribe((res) => {

          var invalid = res.data[0].isokay;

          if (invalid == 2) {

            this.pre_sender_postcode = '';
            this.is_sender_postcode = false;
            this.msg_sender_postcode = 'Postcode is invalid';

          } else {

            if (this.pre_sender_postcode < 10000) this.pre_sender_postcode = '0' + this.pre_sender_postcode;
            this.is_sender_postcode = true;
          }

        });


      }
      else {
        this.pre_sender_postcode = '';
        this.is_sender_postcode = false;
        this.msg_sender_postcode = 'Postcode must contain digit only';
      }

    }

    console.log('sender_postcode = ' + this.pre_sender_postcode);
    console.log('is_sender_postcode = ' + this.is_sender_postcode);

    this.checkAll();
  }

  sender_city() {
    if (this.pre_sender_city == null || this.pre_sender_city == undefined) {
      this.is_sender_city = false;
    }
    else if (this.pre_sender_city.length == 0) {
      this.is_sender_city = false;
    }
    else if (this.pre_sender_city.length == '') {
      this.is_sender_city = false;
    }
    else {
      this.is_sender_city = true;
    }

    console.log('sender_city = ' + this.pre_sender_city);
    console.log('is_sender_city = ' + this.is_sender_city);

    this.checkAll();
  }

  sender_state() {
    if (this.pre_sender_state == null || this.pre_sender_state == undefined) {
      this.is_sender_state = false;
    }
    else if (this.pre_sender_state.length == 0) {
      this.is_sender_state = false;
    }
    else if (this.pre_sender_state.length == '') {
      this.is_sender_state = false;
    }
    else {
      this.is_sender_state = true;
    }

    console.log('sender_state = ' + this.pre_sender_state);
    console.log('is_sender_state = ' + this.is_sender_state);

    this.checkAll();
  }

  sender_phone() {

    console.log(this.pre_sender_phone.length);

    if (this.pre_sender_phone == null || this.pre_sender_phone == undefined) {
      this.is_sender_phone = false;
    }
    else if (this.pre_sender_phone.length == 0) {
      this.is_sender_phone = false;
    }
    else if (this.pre_sender_phone.length == '') {
      this.is_sender_phone = false;
    }
    else {
      if (this.pre_sender_phone.match(/^[0-9]+$/) != null) {
        if (this.pre_sender_phone.length < 10) {
          this.pre_sender_phone = '';
          this.is_sender_phone = false;
          this.msg_sender_phone = 'Phone number is invalid';
        } else this.is_sender_phone = true;
      }
      else {
        this.pre_sender_phone = '';
        this.is_sender_phone = false;
        this.msg_sender_phone = 'Phone must contain digit only';
      }
    }

    console.log('sender_phone = ' + this.pre_sender_phone);
    console.log('is_sender_phone = ' + this.is_sender_phone);

    this.checkAll();
  }



  receiver_firstname() {
    if (this.pre_receiver_firstname == null || this.pre_receiver_firstname == undefined) {
      this.is_receiver_firstname = false;
    }
    else if (this.pre_receiver_firstname.length == 0) {
      this.is_receiver_firstname = false;
    }
    else if (this.pre_receiver_firstname.length == '') {
      this.is_receiver_firstname = false;
    }
    else {
      this.is_receiver_firstname = true;
    }

    console.log('receiver_firstname = ' + this.pre_receiver_firstname);
    console.log('is_receiver_firstname = ' + this.is_receiver_firstname);

    this.checkAll();
  }

  receiver_address1() {
    if (this.pre_receiver_address1 == null || this.pre_receiver_address1 == undefined) {
      this.is_receiver_address1 = false;
    }
    else if (this.pre_receiver_address1.length == 0) {
      this.is_receiver_address1 = false;
    }
    else if (this.pre_receiver_address1.length == '') {
      this.is_receiver_address1 = false;
    }
    else {
      this.is_receiver_address1 = true;
    }

    console.log('receiver_address1 = ' + this.pre_receiver_address1);
    console.log('is_receiver_address1 = ' + this.is_receiver_address1);

    this.checkAll();
  }

  receiver_address2() {
    if (this.pre_receiver_address2 == null || this.pre_receiver_address2 == undefined) {
      this.is_receiver_address2 = false;
    }
    else if (this.pre_receiver_address2.length == 0) {
      this.is_receiver_address2 = false;
    }
    else if (this.pre_receiver_address2.length == '') {
      this.is_receiver_address2 = false;
    }
    else {
      this.is_receiver_address2 = true;
    }

    console.log('receiver_address2 = ' + this.pre_receiver_address2);
    console.log('is_receiver_address2 = ' + this.is_receiver_address2);

    this.checkAll();
  }

  /*receiver_email() {
    if (this.pre_receiver_email == null || this.pre_receiver_email == undefined) {
      this.is_receiver_email = false;
    }
    else if (this.pre_receiver_email.length == 0) {
      this.is_receiver_email = false;
    }
    else {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(this.pre_receiver_email.toLowerCase())) this.is_receiver_email = true;
      else {
        this.is_receiver_email = false;
        this.pre_receiver_email = '';
        this.msg_receiver_email = 'Email format is not valid';
      }

    }

    console.log('receiver_email = ' + this.pre_receiver_email);
    console.log('is_receiver_email = ' + this.is_receiver_email);

    this.checkAll();
  }*/

  receiver_postcode() {

    console.log(this.pre_receiver_postcode);

    if (this.pre_receiver_postcode == null || this.pre_receiver_postcode == undefined) {
      this.is_receiver_postcode = false;
    }
    else if (this.pre_receiver_postcode == '') {
      this.is_receiver_postcode = false;
    }
    else if (this.pre_receiver_postcode < 1000 || this.pre_receiver_postcode > 99999) {
      this.is_receiver_postcode = false;
      this.pre_receiver_postcode = '';
      this.msg_receiver_postcode = 'The postcode length must equal 5';
    }
    else {
      if (this.pre_receiver_postcode.toString().match(/^[0-9]+$/) != null) {
        var ddd = { postcode: this.pre_receiver_postcode };

        var ddtt = {
          id: 1,
          name: 'checkRange',
          content: ddd
        };

        this.apiService.postData(ddtt).subscribe((res) => {

          var invalid = res.data[0].isokay;

          if (invalid == 2) {

            this.pre_receiver_postcode = '';
            this.is_receiver_postcode = false;
            this.msg_receiver_postcode = 'Postcode is invalid';

          } else {

            if (this.pre_receiver_postcode < 10000) this.pre_receiver_postcode = '0' + this.pre_receiver_postcode;
            this.is_receiver_postcode = true;
          }

        });
      }
      else {
        this.pre_receiver_postcode = '';
        this.is_receiver_postcode = false;
        this.msg_receiver_postcode = 'Postcode must contain digit only';
      }

    }

    console.log('receiver_postcode = ' + this.pre_receiver_postcode);
    console.log('is_receiver_postcode = ' + this.is_receiver_postcode);

    this.checkAll();
  }

  receiver_city() {
    if (this.pre_receiver_city == null || this.pre_receiver_city == undefined) {
      this.is_receiver_city = false;
    }
    else if (this.pre_receiver_city.length == 0) {
      this.is_receiver_city = false;
    }
    else if (this.pre_receiver_city.length == '') {
      this.is_receiver_city = false;
    }
    else {
      this.is_receiver_city = true;
    }

    console.log('receiver_city = ' + this.pre_receiver_city);
    console.log('is_receiver_city = ' + this.is_receiver_city);

    this.checkAll();
  }

  receiver_state() {
    if (this.pre_receiver_state == null || this.pre_receiver_state == undefined) {
      this.is_receiver_state = false;
    }
    else if (this.pre_receiver_state.length == 0) {
      this.is_receiver_state = false;
    }
    else if (this.pre_receiver_state.length == '') {
      this.is_receiver_state = false;
    }
    else {
      this.is_receiver_state = true;
    }

    console.log('receiver_state = ' + this.pre_receiver_state);
    console.log('is_receiver_state = ' + this.is_receiver_state);

    this.checkAll();
  }

  receiver_phone1() {

    console.log(this.pre_receiver_phone1.length);

    if (this.pre_receiver_phone1 == null || this.pre_receiver_phone1 == undefined) {
      this.is_receiver_phone1 = false;
    }
    else if (this.pre_receiver_phone1.length == 0) {
      this.is_receiver_phone1 = false;
    }
    else if (this.pre_receiver_phone1.length == '') {
      this.is_receiver_phone1 = false;
    }
    else {
      if (this.pre_receiver_phone1.match(/^[0-9]+$/) != null) {
        if (this.pre_receiver_phone1.length < 10) {
          this.pre_receiver_phone1 = '';
          this.is_receiver_phone1 = false;
          this.msg_receiver_phone1 = 'Phone number is invalid';
        } else this.is_receiver_phone1 = true;
      }
      else {
        this.pre_receiver_phone1 = '';
        this.is_receiver_phone1 = false;
        this.msg_receiver_phone1 = 'Phone must contain digit only';
      }
    }

    console.log('receiver_phone1 = ' + this.pre_receiver_phone1);
    console.log('is_receiver_phone1 = ' + this.is_receiver_phone1);

    this.checkAll();
  }

  receiver_phone2() {

    console.log(this.pre_receiver_phone2.length);

    if (this.pre_receiver_phone2 == null || this.pre_receiver_phone2 == undefined) {
      this.is_receiver_phone2 = false;
    }
    else if (this.pre_receiver_phone2.length == 0) {
      this.is_receiver_phone2 = false;
    }
    else {
      if (this.pre_receiver_phone2.match(/^[0-9]+$/) != null) {
        if (this.pre_receiver_phone2.length < 10) {
          this.pre_receiver_phone2 = '';
          this.is_receiver_phone2 = false;
          this.msg_receiver_phone2 = 'Phone number is invalid';
        } else this.is_receiver_phone2 = true;
      }
      else {
        this.pre_receiver_phone2 = '';
        this.is_receiver_phone2 = false;
        this.msg_receiver_phone2 = 'Phone must contain digit only';
      }
    }

    console.log('receiver_phone2 = ' + this.pre_receiver_phone2);
    console.log('is_receiver_phone2 = ' + this.is_receiver_phone2);

    this.checkAll();
  }

  parcel_item() {
    if (this.pre_parcel_item == null || this.pre_parcel_item == undefined) {
      this.is_parcel_item = false;
    }
    else if (this.pre_parcel_item.length == 0) {
      this.is_parcel_item = false;
    }
    else if (this.pre_parcel_item.length == '') {
      this.is_parcel_item = false;
    }
    else {
      this.is_parcel_item = true;
    }

    console.log('parcel_item = ' + this.pre_parcel_item);
    console.log('is_parcel_item = ' + this.is_parcel_item);

    this.checkAll();
  }

  parcel_weight() {
    if (this.pre_parcel_weight == null || this.pre_parcel_weight == undefined) {
      this.is_parcel_weight = false;
    }
    else if (this.pre_parcel_weight.length == 0) {
      this.is_parcel_weight = false;
    }
    else if (this.pre_parcel_weight.length == '') {
      this.is_parcel_weight = false;
    }
    else {
      if (this.pre_parcel_weight > 30) {
        this.pre_parcel_weight = '';
        this.is_parcel_weight = false;
        this.msg_parcel_weight = 'Maximum weight is 30 kg';
      } else {
        this.getTariff();
        this.is_parcel_weight = true;
      }
    }

    console.log('parcel_weight = ' + this.pre_parcel_weight);
    console.log('is_parcel_weight = ' + this.is_parcel_weight);

    this.checkAll();
  }

  parcel_height() {
    if (this.pre_parcel_height == null || this.pre_parcel_height == undefined) {
      this.is_parcel_height = false;
    }
    else if (this.pre_parcel_height.length == 0) {
      this.is_parcel_height = false;
    }
    else if (this.pre_parcel_height.length == '') {
      this.is_parcel_height = false;
    }
    else {
      if (this.pre_parcel_height > 105) {
        this.pre_parcel_height = '';
        this.is_parcel_height = false;
        this.msg_parcel_height = 'Maximum height is 105 cm';
      } else {
        this.getTariff();
        this.is_parcel_height = true;
      }
    }

    console.log('parcel_height = ' + this.pre_parcel_height);
    console.log('is_parcel_height = ' + this.is_parcel_height);

    this.checkAll();
  }

  parcel_width() {
    if (this.pre_parcel_width == null || this.pre_parcel_width == undefined) {
      this.is_parcel_width = false;
    }
    else if (this.pre_parcel_width.length == 0) {
      this.is_parcel_width = false;
    }
    else if (this.pre_parcel_width.length == '') {
      this.is_parcel_width = false;
    }
    else {
      if (this.pre_parcel_width > 105) {
        this.pre_parcel_width = '';
        this.is_parcel_width = false;
        this.msg_parcel_width = 'Maximum width is 105 cm';
      } else {
        this.getTariff();
        this.is_parcel_width = true;
      }
    }

    console.log('parcel_width = ' + this.pre_parcel_width);
    console.log('is_parcel_width = ' + this.is_parcel_width);

    this.checkAll();
  }

  parcel_length() {
    if (this.pre_parcel_length == null || this.pre_parcel_length == undefined) {
      this.is_parcel_length = false;
    }
    else if (this.pre_parcel_length.length == 0) {
      this.is_parcel_length = false;
    }
    else if (this.pre_parcel_length.length == '') {
      this.is_parcel_length = false;
    }
    else {
      if (this.pre_parcel_length > 105) {
        this.pre_parcel_length = '';
        this.is_parcel_length = false;
        this.msg_parcel_length = 'Maximum length is 105 cm';
      } else {
        this.is_parcel_length = true;
        this.getTariff();
      }
    }

    console.log('parcel_length = ' + this.pre_parcel_length);
    console.log('is_parcel_length = ' + this.is_parcel_length);



    this.checkAll();
  }

  parcel_content() {
    if (this.pre_parcel_content == null || this.pre_parcel_content == undefined) {
      this.is_parcel_content = false;
    }
    else if (this.pre_parcel_content.length == 0) {
      this.is_parcel_content = false;
    }
    else if (this.pre_parcel_content.length == '') {
      this.is_parcel_content = false;
    }
    else {
      this.is_parcel_content = true;
    }

    console.log('parcel_content = ' + this.pre_parcel_content);
    console.log('is_parcel_content = ' + this.is_parcel_content);

    this.checkAll();
  }

  parcel_description() {
    if (this.pre_parcel_description == null || this.pre_parcel_description == undefined) {
      this.is_parcel_description = false;
    }
    else if (this.pre_parcel_description.length == 0) {
      this.is_parcel_description = false;
    }
    else if (this.pre_parcel_description.length == '') {
      this.is_parcel_description = false;
    }
    else {
      this.is_parcel_description = true;
    }

    console.log('parcel_description = ' + this.pre_parcel_description);
    console.log('is_parcel_description = ' + this.is_parcel_description);

    this.checkAll();
  }

  parcel_payment() {
    if (this.pre_parcel_payment == null || this.pre_parcel_payment == undefined) {
      this.is_parcel_payment = false;
    }
    else if (this.pre_parcel_payment.length == 0) {
      this.is_parcel_payment = false;
    }
    else if (this.pre_parcel_payment.length == '') {
      this.is_parcel_payment = false;
    }
    else {
      this.is_parcel_payment = true;
    }

    console.log('parcel_payment = ' + this.pre_parcel_payment);
    console.log('is_parcel_payment = ' + this.is_parcel_payment);

    this.checkAll();
  }

  checkAll() {
    if (this.is_sender_firstname &&
      this.is_sender_address1 &&
      this.is_sender_address2 &&
      this.is_sender_postcode &&
      this.is_sender_city &&
      this.is_sender_state &&
      this.is_sender_phone &&
      this.is_sender_email
    ) {

      this.isCompleted = true;

    } else {
      this.isCompleted = false;
    }

    if (this.is_receiver_firstname &&
      this.is_receiver_address1 &&
      this.is_receiver_address2 &&
      this.is_receiver_postcode &&
      this.is_receiver_city &&
      this.is_receiver_state &&
      this.is_receiver_phone1 &&
      this.is_receiver_phone2 
      //&&
      //this.is_receiver_email
    ) {

      this.isCompleted2 = true;

    } else {
      this.isCompleted2 = false;
    }

    console.log(this.is_parcel_item);
    console.log(this.is_parcel_content);
    console.log(this.is_parcel_description);
    console.log(this.is_parcel_payment);
    console.log(this.is_parcel_length);
    console.log(this.is_parcel_width);
    console.log(this.is_parcel_height);
    console.log(this.is_parcel_weight);

    if (this.is_parcel_item &&
      this.is_parcel_content &&
      this.is_parcel_description &&
      this.is_parcel_payment &&
      this.is_parcel_length &&
      this.is_parcel_width &&
      this.is_parcel_height &&
      this.is_parcel_weight
    ) {

      this.isCompleted3 = true;

    } else {
      this.isCompleted3 = false;
    }

    console.log(this.isCompleted);
    console.log(this.isCompleted2);
    console.log(this.isCompleted3);

  }

  getIPAddress() {
    this.http.get("https://api.ipify.org/?format=json").subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }


  openDialog(msg): void {
    const dialogRef = this.dialog.open(DialogPosmPage, {
      width: '280px',
      data: { name: msg }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogPosmPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

}